export const menuTheme = {
    baseStyle: {
        list: {
            boxShadow: 'lg',
            p: 1,
            borderRadius: 'md',
        },
        item: {
            borderRadius: 'sm',
            color: 'charcoal.900',
            _hover: {
                bgColor: 'blackAlpha.50',
            },
            _focus: {
                bgColor: 'blackAlpha.50',
            },
        },
    },
};
